import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import styled from 'styled-components';
import MotifButton from '@ey/motif-react-wrapper/Button';
import {
	labels,
	EnterKeyCode,
	pagingOptions,
	currentResource
} from '../../../../util/uiconstants';
import EYMotifSearch from '../../../Common/Search/MotifSearch';
import AssignRole from './assignrole';
import Pagination from '../../../Common/Pagination/PaginationMotif';
import {setIsModalOpen} from '../../../../actions/modalstateactions';
import {clearErrors} from '../../../../actions/erroractions';
import {
	getAdminUserRoles
} from '../../../../actions/admin/manageaccessactions';
import env from '../../../../util/env';
import {toInteger} from 'lodash';
import {getMeCall} from '../../../../actions/admin/mepermissionsactions';
import AccessDeniedMessage from '../../../Common/AccessDeniedMessage/AccessDeniedMessage';
import ManageRolesTable from './managerolestable/managerolestable';
import DeleteRole from './managerolestable/deleterole';
import ModalControl from '../../../Common/Modal/Modal';

function ManageRoles() {
	const adminUserRoles = useSelector((store) => store.adminUserRoles);
	const userPermissions = useSelector((store) => store.userPermissions);

	const history = useHistory();
	const dispatch = useDispatch();

	const [showAssignRoleModal, setShowAssignRoleModal] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [search, setSearch] = useState('');
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [optionPerPage, setOptionPerPage] = useState(pagingOptions.options[0]);
	const [errorMessage, setErrorMessage] = useState(false);
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [isMeCallSent, setIsMeCallSent] = useState(false);
	const [rolePageItems, setRolePageItems] = useState([]);
	const [sortedRoles, setSortedRoles] = useState([]);
	const [filteredRoles, setFilteredRoles] = useState([]);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [roleToDelete, setRoleToDelete] = useState(undefined);
	
	useEffect(() => {
		dispatch(getMeCall()).then(() => setIsMeCallSent(true));
	}, []);

	useEffect(() => {
		if (isMeCallSent && userHasManageAccessPerm()) {
			getUserRoles();
		}
	}, [userPermissions, isMeCallSent]);

	useEffect(() => {
		setPage(1);
		let roleCount = filteredRoles.length;
		let tp = 0;
		if (roleCount % optionPerPage == 0) {
			tp = roleCount / optionPerPage;
			setTotalPages(tp);
		} else {
			tp = toInteger(roleCount / optionPerPage) + 1;
			setTotalPages(tp);
		}
		setupPagination(tp);
	}, [filteredRoles, optionPerPage]);

	useEffect(() => {
		if (sortedRoles && sortedRoles.length && search && search.trim().length) {
			const timer = setTimeout(() => {
				let s = search.trim().toLowerCase();
				let filtered = sortedRoles.filter((role) => {
					if (role.moduleName.toLowerCase().includes(s)) {
						return true;
					} else if (role.roleName.toLowerCase().includes(s)) {
						return true;
					} else if (role.subServiceLineName?.toLowerCase().includes(s)) {
						return true;
					} else if (
						role.localizedCountries?.some((countryItem) =>
							countryItem.name.toLowerCase().includes(s)
						)
					) {
						return true;
					}
				});
				setFilteredRoles(filtered);
			}, 1000);
			return () => clearTimeout(timer);
		} else {
			setFilteredRoles(sortedRoles);
		}
	}, [sortedRoles, search]);

	useEffect(() => {
		let sortedRoles = sortRoles(adminUserRoles);
		setSortedRoles(sortedRoles);
	}, [adminUserRoles]);

	useEffect(() => {
		setIsSubmitted(false);
		if (userHasManageAccessPerm() && isSubmitted && !showAssignRoleModal) {
			getUserRoles();
		}
	}, [isSubmitted]);

	useEffect(() => {
		if (history.location.hash.toLowerCase() == '#assignrole') {
			setShowAssignRoleModal(true);
		}
	}, [history.location]);

	useEffect(() => {
		if (showAssignRoleModal == true) {
			dispatch(clearErrors()).then(function () {
				dispatch(setIsModalOpen(true));
			});
		} else {
			dispatch(clearErrors());
			dispatch(setIsModalOpen(false));
		}
	}, [showAssignRoleModal]);

	const setAssignRoleModalFromChild = (isShow) => {
		setShowAssignRoleModal(isShow);
	};

	const getUserRoles = () => {
		setIsLoading(true);
		let userId = location.pathname.split('/').at(-1);
		let getRolesUrl =
			env.getURL('serviceUrlV2') + 'admin/Users/' + userId + '/roles';
		dispatch(getAdminUserRoles(getRolesUrl))
			.then(() => {})
			.catch((e) => {
				setErrorMessage(e.toString());
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const sortRoles = (roles) => {
		return Array.from(roles)?.sort((role1, role2) => {
			if (role1.moduleName < role2.moduleName) {
				return -1;
			} else if (role1.moduleName > role2.moduleName) {
				return 1;
			} else if (role1.roleName < role2.roleName) {
				return -1;
			} else if (role1.roleName > role2.roleName) {
				return 1;
			} else if (role1.subServiceLineName < role2.subServiceLineName) {
				return -1;
			} else if (role1.subServiceLineName > role2.subServiceLineName) {
				return 1;
			}
			return 0;
		});
	};

	const setupPagination = (totalPages) => {
		setTotalPages(totalPages);
		let rolePages = {};
		for (let i = 0; i < totalPages; i++) {
			rolePages[i + 1] = filteredRoles.slice(i * optionPerPage, (i + 1) * optionPerPage);
		}
		setRolePageItems(rolePages);
	};

	const userHasManageAccessPerm = () =>
		userPermissions?.permissions &&
		(userPermissions.permissions.canCreateUpdateManageAccess ||
			userPermissions.permissions.canReadManageAccess);

	const onDeleteClick = (role) => {
		setShowDeleteModal(true);
		setRoleToDelete(role);
	};

	const onSearchChange = (e) => {};

	const onClearClick = () => {
		setSearch('');
	};

	const paginationHandler = (value) => {
		if (page !== value && page > 0) {
			setPage(value);
		}
	};
	const handlerOptionPage = (value) => {
		if (value !== optionPerPage) {
			setOptionPerPage(value);
			setPage(1);
		}
	};

	const openAssignRoleModal = () => {
		history.replace({
			pathname: history.location.pathname,
			state: {customLabel: history?.location?.state?.customLabel},
			hash: 'assignrole'
		});

		setShowAssignRoleModal(true);
	};

	const onModalClose = (isDeletedSuccess) => {
		setShowDeleteModal(false);
		setRoleToDelete(undefined);
		if (isDeletedSuccess) getUserRoles();
	}

	return !userHasManageAccessPerm() ? (
		<AccessDeniedMessage permissionMesage={labels.insufficientPermission} />
	) : (
		<Mainwrapper>
			<section className="manageaccess mainResponsiveWrapper">
				<section
					className="toastMessage"
					style={{display: errorMessage ? 'block' : 'none'}}
				></section>
				<section className="add-on">
					<section className="search">
						<EYMotifSearch
							placeholder={labels.searchUserText}
							value={search}
							onChange={(e) => setSearch(e.target.value)}
							onSearchButtonClick={onSearchChange}
							onClear={onClearClick}
							onKeyDown={(e) => {
								if (
									e &&
									(e.which === EnterKeyCode || e.keyCode === EnterKeyCode)
								) {
									onSearchChange(e);
								}
							}}
						/>
					</section>
					<section className="adduser">
						<MotifButton
							aria-label="Assign role"
							variant="text-alt"
							disabled={false}
							onClick={() => {
								openAssignRoleModal();
							}}
						>
							{labels.manageAccessAssignRole}
						</MotifButton>
					</section>
				</section>
				<ManageRolesTable
					isLoading={isLoading}
					onDeleteClick={onDeleteClick}
					data={rolePageItems[page]}
					rolesExist={sortedRoles?.length}
				/>
				{!isLoading && showAssignRoleModal ? (
					<AssignRole
						setAssignRoleModalFromChild={setAssignRoleModalFromChild}
						showAssignRoleModal={showAssignRoleModal}
						setIsSubmitted={setIsSubmitted}
						customLabel={history?.location?.state?.customLabel}
					/>
				) : (
					''
				)}
			</section>
			{!isLoading && <section className="pagerholder">
				<Pagination
					styleName="manageaccess-paging mainResponsiveWrapper"
					options={pagingOptions.options}
					pageSize={optionPerPage}
					showText={currentResource.common.pagination.show}
					onPageSizeChange={(pageSize) => {
						handlerOptionPage(pageSize);
					}}
					totalPages={totalPages}
					currentPage={page}
					onPageChange={(pageNumber) => {
						paginationHandler(pageNumber);
					}}
				/>
			</section>}
			<section className="showTicketModal">
				<ModalControl
					className=""
					title={labels.manageAccessDeleteRoleModalHeader}
					onOkClick={() => {}}
					onHide={() => setShowDeleteModal(false)}
					isOkButtonDisabled={false}
					show={showDeleteModal}
					modalsize="x-small"
					showButtons={false}
					modalContainerClass={"deleteRole-modal"}
					closeTitle={labels.close}
					role="dialog"
					focusTrapActive={false}
				>
					<DeleteRole roleToDelete={roleToDelete} onModalClose={onModalClose} />
				</ModalControl>
			</section>
		</Mainwrapper>
	);
}

const Mainwrapper = styled.section`
	overflow: hidden;
	padding-top: var(--spacing-xx-large);
	//heading
	.manageaccess {
		.pageheading {
			display: flex;
			svg {
				min-width: var(--px-25) !important;
				min-height: var(--px-25) !important;
				margin-right: var(--px-10);
			}

			h3 {
				margin: 0;
				line-height: var(--px-25);
			}
		}
	}

	//addon

	.add-on {
		display: flex;
		margin-right: auto;
		padding-bottom: var(--spacing-x-large);
		.adduser {
			display: flex;
			align-items: end;
		}

		.search {
			width: var(--px-400);
			margin-right: auto;
		}
	}

	//pagination

	.pagerholder {
		width: calc(100vw - var(--px-80));
		margin: 0 auto;
		max-width: 2048px;
		display: flex;
		padding: var(--spacing-x-large) 0;
	}

	.manageaccess-paging {
		justify-content: flex-end;
		line-height: normal;
		min-width: auto !important;
		font-size: var(--px-14);
	}

	.norecord {
		height: calc(100vh - var(--px-385));
		display: inline-block;
		width: 100%;
		display: flex;
		justify-content: center;
		flex: 0 auto;
		align-items: center;
		font-size: var(--px-16);
		color: var(--neutrals-700);
	}
`;

export default ManageRoles;
